import { useCallback, useMemo, useState } from "react";
import getClientFormCopy, {
  CLIENT_FORM_TYPES,
  CLIENT_FORM_TYPE,
} from "../copy/clientFormCopy";
import { CHECK_IN_LANG } from "./useCheckInLanguage";

export { CHECK_IN_LANG as FORM_LANG, CLIENT_FORM_TYPE };

/**
 * Idioma local por formulario. Default inglés; no persiste entre vistas.
 * @param {"ultrasound"|"massage"|"dna"} formType
 */
export function useClientFormLanguage(formType) {
  if (!CLIENT_FORM_TYPES.includes(formType)) {
    throw new Error(`useClientFormLanguage: tipo desconocido "${formType}"`);
  }

  const [lang, setLang] = useState(CHECK_IN_LANG.EN);

  const setEnglish = useCallback(() => setLang(CHECK_IN_LANG.EN), []);
  const setSpanish = useCallback(() => setLang(CHECK_IN_LANG.ES), []);

  const copy = useMemo(
    () => getClientFormCopy(formType, lang),
    [formType, lang]
  );

  return {
    lang,
    setEnglish,
    setSpanish,
    copy,
  };
}

export default useClientFormLanguage;
